import React from 'react';
import { Link } from 'react-router-dom';
import coverImage from '../../img/xray_logo_vert.png';
import Logo from '../../img/fpg_logo.png';
import lonelyHandsCover from '../../img/lhcover.png'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#ffffff',
    color: '#333',
    fontFamily: '"Inter", sans-serif',
  },
  // HERO SECTION
  hero: {
    height: '85vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'radial-gradient(circle at 50% 50%, #ffffff 0%, #f0f0f5 100%)', 
    textAlign: 'center',
    padding: '0 20px',
  },
  // NEW: Container to hold Logo + Text side-by-side
  heroHeader: {
    display: 'flex',
    alignItems: 'center', // Vertically center them
    justifyContent: 'center',
    gap: '25px', // Space between logo and text
    marginBottom: '20px',
    flexWrap: 'wrap', // Wrap on mobile so it doesn't break
  },
  // NEW: Large Logo Style
  heroLogo: {
    height: '100px', // Matches the visual weight of the 5rem text
    width: 'auto',
    objectFit: 'contain',
    filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.1))', // Subtle shadow for depth
  },
  heroTitle: {
    fontSize: '5rem',
    fontWeight: '900',
    margin: 0, // Remove default margin since container handles spacing
    letterSpacing: '-2px',
    background: '-webkit-linear-gradient(45deg, #333, #b026ff)', 
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    lineHeight: '1', // Tighter line height
  },
  heroSubtitle: {
    fontSize: '1.5rem',
    color: '#666',
    marginBottom: '50px',
    maxWidth: '650px',
    lineHeight: '1.6',
    fontWeight: '400',
  },
  ctaButton: {
    padding: '18px 50px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#b026ff',
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    textDecoration: 'none',
    boxShadow: '0 10px 25px rgba(176, 38, 255, 0.3)',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  // PROJECTS SECTION
  section: {
    padding: '100px 20px',
    width: '100%',
    maxWidth: '1200px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: '800',
    marginBottom: '60px',
    color: '#333',
    position: 'relative',
  },
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '40px',
    width: '100%',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    overflow: 'hidden',
    width: '380px',
    boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
    transition: 'transform 0.3s, box-shadow 0.3s',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #eee',
  },
  cardImage: {
    height: '220px',
    width: '100%',
    objectFit: 'cover',
    borderBottom: '1px solid #eee',
  },
  cardContent: {
    padding: '30px',
    textAlign: 'left',
  },
  cardTitle: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#333',
  },
  cardText: {
    color: '#666',
    lineHeight: '1.6',
    marginBottom: '25px',
  },
  textLink: {
    color: '#b026ff',
    fontWeight: 'bold',
    textDecoration: 'none',
    fontSize: '1.1rem',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  }
};

export default function HomePage() {
  return (
    <div style={styles.container}>
      
      {/* --- HERO SECTION --- */}
      <div style={styles.hero}>
        {/* If you have the logo image here, it will POP against this light background */}
        {/* <img src={Logo} style={{width: '150px', marginBottom: '20px'}} /> */}
        
        <div style={styles.heroHeader}>
          <img src={Logo} style={styles.heroLogo} alt="Logo" />
          <h1 style={styles.heroTitle}>FOREPLAY GAMES</h1>
        </div>
        <p style={styles.heroSubtitle}>
          We build worlds where gameplay meets desire. 
          Narrative-driven, uncensored, and unforgettable.
        </p>
        <Link to="/games/3xr" style={styles.ctaButton}>
          Check out our Games
        </Link>
      </div>

      {/* --- CURRENT PROJECTS --- */}
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>
          Current Projects
          {/* Little underline decoration */}
          <span style={{
            position: 'absolute', bottom: '-15px', left: '50%', transform: 'translateX(-50%)', 
            width: '60px', height: '4px', backgroundColor: '#b026ff', borderRadius: '2px'
          }}/>
        </h2>
        
        <div style={styles.grid}>
          
          {/* CARD 1: 3XRay */}
          <div style={styles.card}>
            {/* REAL IMAGE REPLACES PLACEHOLDER */}
            <img 
              src={coverImage} 
              alt="3XRay Cover Art" 
              style={styles.cardImage} 
            />
            
            <div style={styles.cardContent}>
              {/* Flex container to put Title and Badge on the same line */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h3 style={{ ...styles.cardTitle, margin: 0 }}>3XRay</h3>
                <span style={{ fontSize: '0.75rem', backgroundColor: '#ffe6f2', color: '#ff007f', padding: '4px 8px', borderRadius: '4px', fontWeight: 'bold' }}>
                  AI-ASSISTED
                </span>
              </div>

              <p style={styles.cardText}>
                Use your X-Ray vision to uncover secrets, navigate social hierarchies, and find romance where you least expect it.
              </p>
              
              <Link to="/games/3xr" style={styles.textLink}>
                View Game Page →
              </Link>
            </div>
          </div>

          {/* CARD 2: LonelyHands */}
          <div style={styles.card}>
            {/* REAL IMAGE REPLACES PLACEHOLDER */}
            <img 
              src={lonelyHandsCover} 
              alt="LonelyHands Cover Art" 
              style={styles.cardImage} 
            />
            
            <div style={styles.cardContent}>
              {/* Flex container to put Title and Badge on the same line */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h3 style={{ ...styles.cardTitle, margin: 0 }}>LonelyHands</h3>
                <span style={{ fontSize: '0.75rem', backgroundColor: '#e6f8f0', color: '#10b981', padding: '4px 8px', borderRadius: '4px', fontWeight: 'bold' }}>
                  NO AI
                </span>
              </div>

              <p style={styles.cardText}>
                A minimalist, pixel-art desktop simulator. Pay your tuition by ghostwriting for top models on a subscription platform, balancing your digital hustle with your real life.
              </p>
              
              <Link to="/games/lonelyhands" style={styles.textLink}>
                View Game Page →
              </Link>
            </div>
          </div>

        </div>
      </div>

      {/* --- NEWSLETTER / SOCIALS --- */}
      <div style={{...styles.section, backgroundColor: '#f9f9f9', width: '100%', maxWidth: '100%'}}>
        <h2 style={{fontSize: '2rem', marginBottom: '20px', fontWeight: 'bold'}}>Join The Community</h2>
        <p style={{color: '#666', marginBottom: '30px', textAlign: 'center'}}>
          Get exclusive sketches, devlogs, and early builds.
        </p>
        
        <div style={{display: 'flex', gap: '20px'}}>
           
           {/* TWITTER / X - Now a working link! */}
           <a 
             href="https://x.com/ForeplayGames" 
             target="_blank" 
             rel="noopener noreferrer"
             style={{...styles.ctaButton, backgroundColor: '#000', fontSize: '1rem', display: 'flex', alignItems: 'center'}}
           >
             Twitter / X
           </a>

           {/* DISCORD - Still a placeholder button for now */}
           <button 
             style={{...styles.ctaButton, backgroundColor: '#5865F2', fontSize: '1rem', cursor: 'not-allowed', opacity: 0.7}}
             title="Discord Community Opening Soon!"
           >
             Discord (Coming Soon)
           </button>

        </div>
      </div>

    </div>
  );
}